import { render, staticRenderFns } from "./companyKnowledgeBase.vue?vue&type=template&id=d0dec044&scoped=true&"
import script from "./companyKnowledgeBase.vue?vue&type=script&lang=js&"
export * from "./companyKnowledgeBase.vue?vue&type=script&lang=js&"
import style0 from "./companyKnowledgeBase.vue?vue&type=style&index=0&id=d0dec044&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0dec044",
  null
  
)

export default component.exports